import { State, useHookstate } from "@hookstate/core";
import Eye from "../../assets/icons/Eye";
import Warning from "../../assets/icons/Warning";
import { DisciplinaryTableItemType } from "../../misc/types";
import { Demerit, DisciplinaryDefaultCaseTableState } from "../../types";
import { Avatar } from "../Avatar";
import { getDateOnly, updateLocalStateRaw } from "../../misc/utils";
import { demeritStatusMapper } from "../../misc/constants";
import { ReactNode } from "react";
import Modal from "../Modal/Modal";
import { DisciplinaryTableStudentsState } from "../disciplinary-table/DisciplinaryStudents";
import { DisciplinaryDemerit } from "../disciplinary-table/DisciplinaryDemerit";

type DisciplinaryTableItemPropsType = {
  item: Demerit;
  index: number;
  parentState?: State<DisciplinaryDefaultCaseTableState>;
  onCheckboxCheck?: (item: Demerit) => () => void;
  isChecked?: boolean;
  onViewClick?: (item: Demerit) => () => void;
  customButtonRender?: (item: Demerit) => ReactNode;
};

const DisciplinaryTableItem = ({
  item,
  index,
  onCheckboxCheck,
  isChecked,
  onViewClick,
  customButtonRender,
}: DisciplinaryTableItemPropsType) => {
  const localState = useHookstate<DisciplinaryTableStudentsState>({
    files: {},
    page: 0,
    loading: false,
    total: 0,
  });
  const state = localState.get();
  const isAddDemeritModalOpen = Boolean(state.isAddDemeritModalOpen);
  const userData = item.main_user?.json_saved_data || item.students;

  return (
    <tr key={index} className='border-b border-gray-200'>
      {onCheckboxCheck && (
        <td className='px-4 py-2'>
          <input
            type='checkbox'
            checked={isChecked}
            onChange={onCheckboxCheck(item)}
            disabled={item.status !== 0}
            title={item.status !== 0 ? "Нельзя добавить в новое дело" : ""}
          />
        </td>
      )}
      <td className='px-4 py-2'>{item.demerit_type?.name}</td>
      <td className='px-4 py-2'>
        <div className='flex items-center gap-2'>
          {/* <Avatar user={item.main_user} /> */}
          {item.main_user ? <Avatar user={item.main_user} /> : null}
          <span>
            {Array.isArray(userData)
              ? userData
                  .map(
                    (user) =>
                      `${user.json_saved_data.firstname} ${user.json_saved_data.lastname}`
                  )
                  .join(", ")
              : `${userData?.firstname} ${userData?.lastname}`}
          </span>
        </div>
      </td>
      <td className='px-4 py-2'>{getDateOnly(item.createdAt)}</td>
      <td className='px-4 py-2'>
        <p className='flex items-center gap-1 text-orange-500 '>
          <Warning />
          {demeritStatusMapper[item.status]}
        </p>
      </td>
      {customButtonRender ? (
        customButtonRender(item)
      ) : (
        <td className='px-4 py-2'>
          <button
            {...(onViewClick ? { onClick: onViewClick(item) } : {})}
            className='flex items-center gap-1 px-3 py-1 border border-gray-300 rounded-lg text-gray-600 hover:bg-gray-100'
          >
            {" "}
            <Eye />
            Подробнее
          </button>
        </td>
      )}
    </tr>
  );
};

export default DisciplinaryTableItem;
